import { Controller } from '@hotwired/stimulus'

export default class CountdownController extends Controller {
  static targets = ['countdown'];

  static values = {
    timestamp: Number,
    mode: String,
    reloadOnComplete: { type: Boolean, default: false },
    withParenthesis: { type: Boolean, default: false },
  };

  initialize() {
    this.now = new Date(this.timestampValue * 1000);
  }

  connect() {
    this._update();
    this.interval = setInterval(() => this._update(), 1000);
  }

  _update() {
    let diff = this.now - new Date();
    let hours = diff / 1000 / 3600;
    let minutes = (hours - Math.floor(hours)) * 60;
    let seconds = (minutes - Math.floor(minutes)) * 60;

    if (diff <= 0) {
      if (this.reloadOnCompleteValue) {
        Turbo.visit(window.location.href, {frame: '_top', action: 'replace'});
      } else {
        this.dispatch('completed', {bubbles: true});
      }

      clearInterval(this.interval);

      return;
    }

    if (this.modeValue === 'detailed') {
      this._renderDetailedCountdown(diff, hours, minutes, seconds);
    } else if (this.modeValue === 'secondsOnly') {
      this._renderSecondsOnlyCountdown(seconds);
    }
  }

  _renderDetailedCountdown(diff, hours, minutes, seconds) {
    this.countdownTargets.forEach((target) => {
      target.innerText = `${Math.floor(hours)}h ${Math.floor(minutes)}m`;

      if ((diff / 1000) < 3600) {
        target.innerText += ` ${Math.floor(seconds)}s`;
      }

      if (this.withParenthesisValue) {
        target.innerText = `(${target.innerText})`;
      }
    });
  }

  _renderSecondsOnlyCountdown(seconds) {
    this.countdownTargets.forEach((target) => {
      target.innerText = `${Math.floor(seconds)}`;

      if (this.withParenthesisValue) {
        target.innerText = `(${target.innerText})`;
      }
    })
  }

  disconnect() {
    clearInterval(this.interval);
  }
}
